import { render, staticRenderFns } from "./RealmList.vue?vue&type=template&id=3d2b15c9&"
import script from "./RealmList.vue?vue&type=script&lang=js&"
export * from "./RealmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports